
import { defineComponent, onMounted, computed, ref, watchEffect } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import ExpertDetailsCard from "@/components/cards/ExpertDetailsCard.vue";
import objectPath from "object-path";

export default defineComponent({
  name: "find-experts",
  components: {
    ExpertDetailsCard,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const areAtleastThreeExpertsConnected = computed(() => {
      return (
        objectPath.get(user.value, "founderRequisiteExpert.length", 0) >= 3
      );
    });
    const founderRequisiteExperts = ref<Array<Record<string, unknown>>>([]);
    watchEffect(() => {
      founderRequisiteExperts.value = user.value.founderRequisiteExpert;
    });
    const isAlreadyConnected = (id) => {
      return founderRequisiteExperts.value.some((expert) => {
        return objectPath.get(expert, "id", false) == id;
      });
    };
    const expertRequisiteConnectionStatus = computed(() => {
      const temp = {};
      founderRequisiteExperts.value.forEach((expert) => {
        temp[(expert as { id })?.id] =
          (expert as { pivot: { status } })?.pivot?.status ?? "";
      });
      return temp;
    });
    const expertise = computed(() => store.getters.expertiseGetter);
    const industrySectors = computed(() => store.getters.industrySectorsGetter);
    const selectedExpertise = ref<Array<number>>([]);
    const selectedIndustrySectors = ref<Array<number>>([]);
    const filteredExperts = computed(() => store.getters.filteredExpertsGetter);
    const showError = ref<boolean>(false);
    const addToExpertise = (event) => {
      showError.value = false;
      if (event.target.checked) {
        selectedExpertise.value = [
          ...selectedExpertise.value,
          event.target.dataset["id"],
        ];
      } else {
        selectedExpertise.value = selectedExpertise.value.filter((e) => {
          return e != event.target.dataset["id"];
        });
      }
      findExperts();
    };
    const addToIndustrySectors = (event) => {
      showError.value = false;
      if (event.target.checked) {
        selectedIndustrySectors.value = [
          ...selectedIndustrySectors.value,
          event.target.dataset["id"],
        ];
      } else {
        selectedIndustrySectors.value = selectedIndustrySectors.value.filter(
          (i) => {
            return i != event.target.dataset["id"];
          }
        );
      }
      findExperts();
    };
    const findExperts = async () => {
      if (
        !selectedIndustrySectors.value.length ||
        !selectedExpertise.value.length
      ) {
        showError.value = true;
        return;
      }
      try {
        const response = await store.dispatch(Actions.FIND_EXPERTS, {
          industrySectorIds: selectedIndustrySectors.value,
          expertIds: selectedExpertise.value,
        });
        if (response !== true) throw new Error();
      } catch (err) {
        //
      }
    };
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Find Experts", []);
      if (!expertise.value.length) store.dispatch(Actions.GET_EXPERTISE);
      if (!industrySectors.value.length)
        store.dispatch(Actions.GET_INDUSTRY_SECTORS);
    });

    return {
      areAtleastThreeExpertsConnected,
      showError,
      expertise,
      industrySectors,
      addToExpertise,
      addToIndustrySectors,
      findExperts,
      filteredExperts,
      isAlreadyConnected,
      selectedExpertise,
      selectedIndustrySectors,
      expertRequisiteConnectionStatus,
    };
  },
});
